import { Injectable } from '@angular/core';
import { TimezoneServiceBase } from 'src/shared/services/timezone-service-base';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService extends TimezoneServiceBase {
  constructor() { 
    super(true);
  }
}

